import { Col, Table } from "antd";
import React from "react";

function OrderAssetDetails({ orderDetails, isLoading }) {
  const columns = [
    {
      title: "ID",
      key: "referenceId",
      render: ({ referenceId, _id: orderId }) => {
        return <div className="flex items-center gap-2">{referenceId}</div>;
      },
    },
    {
      title: "Ordered",
      dataIndex: "totalRequiredQuantity",
      key: "totalRequiredQuantity",
      render: (text) => text ?? "-",
    },
    {
      title: "Shipped",
      dataIndex: "totalShippedQuantity",
      key: "totalShippedQuantity",
      render: (text) => text ?? "-",
    },
    {
      title: "Processing",
      dataIndex: "totalProcessorPingQuantity",
      key: "totalProcessorPingQuantity",
      render: (text) => text ?? "-",
    },
    {
      title: "Returned",
      dataIndex: "totalReturnedQuantity",
      key: "totalReturnedQuantity",
      render: (text) => text ?? "-",
    },
  ];

  return (
    <>
      <Col span={24} className="flex justify-between border-t-2 pt-2">
        <p className="text-lg">Asset Details</p>
      </Col>

      <Table
        className="mt-4 w-full"
        dataSource={orderDetails ? [orderDetails] : []}
        columns={columns}
        rowKey={"_id"}
        pagination={false}
        loading={isLoading}
      />
    </>
  );
}

export default OrderAssetDetails;
